module.exports = __webpack_public_path__ + "img/sld_icog_panel.db24c8a5.svg";